import React from 'react';
import './styles.scss';
import { Container } from '../helpers/Grid';
import { ImageBasic, Link } from '../common';
import Countdown from '../Countdown';
import CountdownModuleProps from './type';

const CountdownModule = ({
  patternImageTop,
  patternImageBottom,
  countdownLogo,
  countdownTitle,
  countdownDate,
  countdown,
  linkOne,
  linkTwo,
  sponsorLogo,
  mobileLinkOn,
}: CountdownModuleProps) => (
  <section className="countdown-module">
    {(linkOne && mobileLinkOn) && (
      <span className="countdown-module__mobile-link">
        <Link
          {...linkOne}
          iconAfter={{
            title: 'arrow-right',
            reference: '#icon-think-arrow',
          }}
        />
      </span>
    )}
    {patternImageTop && (
      <span className="countdown-module__pattern--top">
        <ImageBasic image={patternImageTop} />
      </span>
    )}

    {patternImageBottom && (
      <span className="countdown-module__pattern--bottom">
        <ImageBasic image={patternImageBottom} />
      </span>
    )}

    <Container>
      <div className="countdown-module__section__left">
        {countdownLogo && (
          <div className="countdown-module__logo">
            <ImageBasic image={countdownLogo} />
          </div>
        )}
        {countdownTitle && (
          <h3 className="countdown-module__title">
            {countdownTitle}
          </h3>
        )}
        {countdownDate && (
          <div className="countdown-module__date">
            {countdownDate}
          </div>
        )}

        {(linkOne || linkTwo) && (
          <div className="countdown-module__links">
            {linkOne && (
              <span className="countdown-module__link">
                <Link
                  {...linkOne}
                  iconAfter={{
                    title: 'arrow-right',
                    reference: '#icon-think-arrow',
                  }}
                />
              </span>
            )}

            {linkTwo && (
              <span className="countdown-module__link">
                <Link
                  {...linkTwo}
                  iconAfter={{
                    title: 'arrow-right',
                    reference: '#icon-think-arrow',
                  }}
                />
              </span>
            )}
          </div>
        )}
      </div>

      <div className="countdown-module__section__right">
        <Countdown timestamp={countdown} areUnitsShortened />

        {sponsorLogo && (
          <div className="countdown-module__sponsor-logo">
            <ImageBasic image={sponsorLogo} />
          </div>
        )}
      </div>
    </Container>
  </section>
);

export default CountdownModule;
